import React, { useState } from 'react';
import './OrderForm.css';
import { FaTimes, FaShoppingCart, FaUser, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { API_URL } from '../config';

const OrderForm = ({ product, onClose, onOrderSuccess }) => {
  const [formData, setFormData] = useState({
    customer_name: '',
    customer_email: '',
    customer_phone: '',
    customer_address: '',
    customer_city: 'İstanbul',
    quantity: 1,
    notes: ''
  });

  const [loading, setLoading] = useState(false);
  const [orderStep, setOrderStep] = useState('form'); // form, confirmation, success

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.customer_name || !formData.customer_phone || !formData.customer_address) {
      alert('Lütfen zorunlu alanları doldurunuz');
      return;
    }

    setOrderStep('confirmation');
  };

  const handleConfirmOrder = async () => {
    setLoading(true);
    
    const total_price = product.price * parseInt(formData.quantity);
    
    const orderData = {
      ...formData,
      product_id: product.id,
      quantity: parseInt(formData.quantity),
      total_price: total_price,
      payment_method: 'cash'
    };

    try {
      const response = await fetch(`${API_URL}?action=add_order`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(orderData)
      });

      const data = await response.json();
      
      if (data.success) {
        setOrderStep('success');
        if (onOrderSuccess) {
          onOrderSuccess();
        }
      } else {
        alert('Hata: ' + data.message);
      }
    } catch (error) {
      alert('Sipariş işlenirken hata oluştu');
      console.error(error);
    }
    
    setLoading(false);
  };

  const total_price = product.price * parseInt(formData.quantity);

  return (
    <div className="order-form-overlay">
      <div className="order-form-container">
        <button className="close-btn" onClick={onClose}>
          <FaTimes />
        </button>

        {orderStep === 'form' && (
          <div className="form-step">
            <div className="form-header">
              <FaShoppingCart className="form-icon" />
              <h2>Siparişinizi Tamamlayın</h2>
              <p className="product-name">{product.name}</p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label><FaUser /> Adınız ve Soyadınız *</label>
                <input
                  type="text"
                  name="customer_name"
                  value={formData.customer_name}
                  onChange={handleInputChange}
                  placeholder="Müşteri Adı"
                  required
                />
              </div>

              <div className="form-group">
                <label>Email Adresiniz</label>
                <input
                  type="email"
                  name="customer_email"
                  value={formData.customer_email}
                  onChange={handleInputChange}
                  placeholder="ornek@email.com"
                />
              </div>

              <div className="form-group">
                <label><FaPhone /> Telefon Numarası *</label>
                <input
                  type="tel"
                  name="customer_phone"
                  value={formData.customer_phone}
                  onChange={handleInputChange}
                  placeholder="(5xx) xxx-xxxx"
                  required
                />
              </div>

              <div className="form-group">
                <label><FaMapMarkerAlt /> Adres *</label>
                <textarea
                  name="customer_address"
                  value={formData.customer_address}
                  onChange={handleInputChange}
                  placeholder="Açık adres, mahalle, cadde vb."
                  rows="3"
                  required
                />
              </div>

              <div className="form-group">
                <label>İlçe</label>
                <select
                  name="customer_city"
                  value={formData.customer_city}
                  onChange={handleInputChange}
                >
                  <option>Beşiktaş</option>
                  <option>Şişli</option>
                  <option>Fatih</option>
                  <option>Kadıköy</option>
                  <option>Üsküdar</option>
                  <option>Pendik</option>
                  <option>Bahçelievler</option>
                  <option>Diğer</option>
                </select>
              </div>

              <div className="form-group">
                <label>Miktar</label>
                <div className="quantity-selector">
                  <button
                    type="button"
                    onClick={() => setFormData(prev => ({
                      ...prev,
                      quantity: Math.max(1, parseInt(prev.quantity) - 1)
                    }))}
                  >
                    −
                  </button>
                  <input
                    type="number"
                    min="1"
                    value={formData.quantity}
                    onChange={handleInputChange}
                    name="quantity"
                  />
                  <button
                    type="button"
                    onClick={() => setFormData(prev => ({
                      ...prev,
                      quantity: parseInt(prev.quantity) + 1
                    }))}
                  >
                    +
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label>Özel Notlar (İsteğe Bağlı)</label>
                <textarea
                  name="notes"
                  value={formData.notes}
                  onChange={handleInputChange}
                  placeholder="Örn: Tatlı sevmiyorum, ek salsa istiyorum vb."
                  rows="2"
                />
              </div>

              <div className="price-summary">
                <div className="price-row">
                  <span>Birim Fiyatı:</span>
                  <span>₺{parseFloat(product.price).toFixed(2)}</span>
                </div>
                <div className="price-row">
                  <span>Miktar:</span>
                  <span>{formData.quantity}</span>
                </div>
                <div className="price-row total">
                  <span>Toplam Tutar:</span>
                  <span>₺{total_price.toFixed(2)}</span>
                </div>
                <div className="payment-info">
                  <p>💳 <strong>Ödeme Yöntemi:</strong> Kapıda Ödeme</p>
                  <p className="info-text">Siparişiniz onaylandıktan sonra tarafımızdan sizinle iletişime geçeceğiz.</p>
                </div>
              </div>

              <button type="submit" className="submit-btn">
                Siparişi Onayla
              </button>
            </form>
          </div>
        )}

        {orderStep === 'confirmation' && (
          <div className="confirmation-step">
            <div className="confirmation-header">
              <FaShoppingCart className="form-icon" />
              <h2>Siparişinizi Onaylayın</h2>
            </div>

            <div className="confirmation-details">
              <h3>Müşteri Bilgileri</h3>
              <div className="detail-row">
                <span>Ad Soyad:</span>
                <strong>{formData.customer_name}</strong>
              </div>
              <div className="detail-row">
                <span>Telefon:</span>
                <strong>{formData.customer_phone}</strong>
              </div>
              <div className="detail-row">
                <span>Email:</span>
                <strong>{formData.customer_email || '-'}</strong>
              </div>
              <div className="detail-row">
                <span>Adres:</span>
                <strong>{formData.customer_address}</strong>
              </div>
              <div className="detail-row">
                <span>İlçe:</span>
                <strong>{formData.customer_city}</strong>
              </div>

              <h3 style={{ marginTop: '1.5rem' }}>Sipariş Detayları</h3>
              <div className="detail-row">
                <span>Ürün:</span>
                <strong>{product.name}</strong>
              </div>
              <div className="detail-row">
                <span>Miktar:</span>
                <strong>{formData.quantity}</strong>
              </div>
              <div className="detail-row">
                <span>Birim Fiyatı:</span>
                <strong>₺{parseFloat(product.price).toFixed(2)}</strong>
              </div>
              <div className="detail-row total">
                <span>Toplam Tutar:</span>
                <strong style={{ fontSize: '1.3rem', color: '#c7102f' }}>₺{total_price.toFixed(2)}</strong>
              </div>

              {formData.notes && (
                <div className="detail-row">
                  <span>Notlar:</span>
                  <strong>{formData.notes}</strong>
                </div>
              )}

              <div className="payment-method">
                <p>💳 <strong>Ödeme Yöntemi:</strong> Kapıda Nakit Ödeme</p>
              </div>
            </div>

            <div className="confirmation-actions">
              <button
                className="cancel-btn"
                onClick={() => setOrderStep('form')}
                disabled={loading}
              >
                Geri Dön
              </button>
              <button
                className="confirm-btn"
                onClick={handleConfirmOrder}
                disabled={loading}
              >
                {loading ? 'Gönderiliyor...' : 'Siparişi Gönder'}
              </button>
            </div>
          </div>
        )}

        {orderStep === 'success' && (
          <div className="success-step">
            <div className="success-icon">✓</div>
            <h2>Sipariş Başarıyla Alındı!</h2>
            <div className="success-message">
              <p>Teşekkürler {formData.customer_name}!</p>
              <p>Siparişiniz başarıyla kaydedilmiştir.</p>
              <p className="highlight">Lütfen telefoninizi hazır bulundurunuz. Kısa süre içinde ayrıntılar hakkında sizinle iletişime geçeceğiz.</p>
              
              <div className="order-summary">
                <h3>Sipariş Özeti</h3>
                <p><strong>Ürün:</strong> {product.name}</p>
                <p><strong>Miktar:</strong> {formData.quantity}</p>
                <p><strong>Toplam:</strong> ₺{total_price.toFixed(2)}</p>
              </div>
            </div>
            <button className="close-final-btn" onClick={onClose}>
              Kapat
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderForm;
